export default "__VITE_ASSET__DPtrSb26__"